import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { bidangData } from '../../data/bidangData';
import {
    FaUser,
    FaIdCard,
    FaClipboardList,
    FaCogs,
    FaImages,
    FaCalendarAlt,
    FaBuilding,
    FaArrowLeft,
    FaPhone,
    FaEnvelope,
    FaSearch,
    FaPlay,
    FaImage
} from 'react-icons/fa';

const BidangPage = () => {
    const { bidangId } = useParams();
    const [activeTab, setActiveTab] = useState('struktur');
    const [selectedImage, setSelectedImage] = useState(null);

    const bidang = bidangData[bidangId];

    if (!bidang) {
        return (
            <div className="container mx-auto px-4 py-12 text-center">
                <FaBuilding className="text-6xl text-gray-300 mx-auto mb-4" />
                <h2 className="text-2xl font-bold text-gray-500 mb-2">Bidang Tidak Ditemukan</h2>
                <p className="text-gray-400">Bidang yang Anda cari tidak tersedia</p>
            </div>
        );
    }

    return (
        <div className="container mx-auto px-4 py-12">
            {/* Header */}
            <div className="mb-8">
                <div className="flex items-center space-x-3 mb-4">
                    <FaBuilding className="text-4xl text-[#0D9488]" />
                    <div>
                        <h1 className="text-3xl md:text-4xl font-bold text-[#1E3A8A]">
                            {bidang.nama}
                        </h1>
                        <p className="text-gray-600 mt-1">
                            Badan Pengelolaan Keuangan dan Aset Daerah Kota Magelang
                        </p>
                    </div>
                </div>
            </div>

            {/* Info Kepala Bidang */}
            <div className="card-glass mb-8">
                <div className="flex flex-col md:flex-row items-center md:items-start gap-6">
                    <div className="w-32 h-32 bg-gradient-to-br from-[#1E3A8A] to-[#0D9488] rounded-full flex items-center justify-center text-white text-4xl font-bold flex-shrink-0">
                        {bidang.nama.charAt(0)}
                    </div>
                    <div className="flex-1 text-center md:text-left">
                        <h2 className="text-2xl font-bold text-[#1E3A8A] mb-2">{bidang.kepala}</h2>
                        {/*<p className="text-gray-600 mb-1 flex items-center justify-center md:justify-start">
                            <FaIdCard className="mr-2 text-[#0D9488]" />
                            NIP. {bidang.nip}
                        </p>*/}
                        <p className="text-gray-600 flex items-center justify-center md:justify-start">
                            <FaUser className="mr-2 text-[#0D9488]" />
                            Kepala {bidang.nama}
                        </p>
                        <div className="flex gap-4 mt-4 justify-center md:justify-start">
                            <button className="flex items-center text-sm bg-[#0D9488]/10 text-[#0D9488] px-4 py-2 rounded-lg hover:bg-[#0D9488]/20 transition-colors">
                                <FaPhone className="mr-2" /> Kontak
                            </button>
                            <button className="flex items-center text-sm bg-[#1E3A8A]/10 text-[#1E3A8A] px-4 py-2 rounded-lg hover:bg-[#1E3A8A]/20 transition-colors">
                                <FaEnvelope className="mr-2" /> Email
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Tab Navigation */}
            <div className="flex flex-wrap gap-2 mb-8 border-b border-gray-200">
                {[
                    //{ id: 'tusi', label: 'Tugas & Fungsi', icon: FaClipboardList },
                    { id: 'struktur', label: 'Struktur Organisasi', icon: FaCogs },
                    //{ id: 'galeri', label: 'Galeri Kegiatan', icon: FaImages }
                ].map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center px-6 py-3 text-sm font-medium transition-all duration-200 border-b-2 ${activeTab === tab.id
                                ? 'border-[#0D9488] text-[#0D9488] bg-[#0D9488]/5'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                    >
                        <tab.icon className="mr-2" />
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab Content */}
            <div>
                {/* Tugas & Fungsi */}
                {activeTab === 'tusi' && (
                    <div className="space-y-8">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                            {/* Tugas */}
                            <div className="card-glass">
                                <h3 className="text-xl font-bold text-[#1E3A8A] mb-6 flex items-center">
                                    <FaClipboardList className="mr-2 text-[#0D9488]" />
                                    Tugas Pokok
                                </h3>
                                <ul className="space-y-4">
                                    {bidang.tusi.tugas.map((item, index) => (
                                        <li key={index} className="flex items-start">
                                            <div className="flex-shrink-0 w-8 h-8 bg-[#0D9488]/10 rounded-full flex items-center justify-center mr-3 mt-0.5">
                                                <span className="text-[#0D9488] font-bold text-sm">{index + 1}</span>
                                            </div>
                                            <span className="text-gray-700">{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            {/* Fungsi */}
                            <div className="card-glass">
                                <h3 className="text-xl font-bold text-[#1E3A8A] mb-6 flex items-center">
                                    <FaCogs className="mr-2 text-[#0D9488]" />
                                    Fungsi
                                </h3>
                                <ul className="space-y-4">
                                    {bidang.tusi.fungsi.map((item, index) => (
                                        <li key={index} className="flex items-start">
                                            <div className="flex-shrink-0 w-8 h-8 bg-[#1E3A8A]/10 rounded-full flex items-center justify-center mr-3 mt-0.5">
                                                <span className="text-[#1E3A8A] font-bold text-sm">{index + 1}</span>
                                            </div>
                                            <span className="text-gray-700">{item}</span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        {/* Info Tambahan */}
                        <div className="card-glass bg-gradient-to-r from-[#1E3A8A] to-[#0D9488] text-white">
                            <div className="text-center">
                                <h3 className="text-xl font-bold mb-4">Komitmen Kami</h3>
                                <p className="text-lg opacity-90">
                                    {bidang.nama} berkomitmen untuk memberikan pelayanan terbaik
                                    dalam pengelolaan keuangan dan aset daerah yang profesional,
                                    akuntabel, dan transparan.
                                </p>
                            </div>
                        </div>
                    </div>
                )}

                {/* Struktur Organisasi */}
                {activeTab === 'struktur' && (
                    <div>
                        <div className="card-glass">
                            <h3 className="text-xl font-bold text-[#1E3A8A] mb-6 flex items-center">
                                <FaCogs className="mr-2 text-[#0D9488]" />
                                Struktur Organisasi {bidang.nama}
                            </h3>

                            <div className="space-y-4">
                                {bidang.struktur.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`p-4 rounded-lg border-l-4 ${index === 0
                                                ? 'border-[#0D9488] bg-[#0D9488]/5'
                                                : 'border-gray-200 bg-gray-50 hover:bg-gray-100 transition-colors'
                                            }`}
                                    >
                                        <div className="flex items-center">
                                            <div className={`w-10 h-10 rounded-full flex items-center justify-center mr-3 ${index === 0 ? 'bg-[#0D9488] text-white' : 'bg-gray-300 text-gray-600'
                                                }`}>
                                                <FaUser />
                                            </div>
                                            <div>
                                                <h4 className={`font-bold ${index === 0 ? 'text-[#0D9488]' : 'text-[#1E3A8A]'}`}>
                                                    {item.jabatan}
                                                </h4>
                                                <p className="text-sm text-gray-600">{item.nama}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* Galeri Kegiatan */}
                {activeTab === 'galeri' && (
                    <div>
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                            {bidang.galeri.map((item) => (
                                <div
                                    key={item.id}
                                    className="card-glass overflow-hidden cursor-pointer hover:shadow-xl transition-all duration-300 group"
                                    onClick={() => setSelectedImage(item)}
                                >
                                    <div className="relative overflow-hidden">
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                            className="w-full h-48 object-cover group-hover:scale-110 transition-transform duration-500"
                                        />
                                        <div className="absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                                            <FaSearch className="text-white text-4xl" />
                                        </div>
                                    </div>
                                    <div className="p-4">
                                        <h4 className="font-semibold text-[#1E3A8A] mb-2 group-hover:text-[#0D9488] transition-colors">
                                            {item.title}
                                        </h4>
                                        <p className="text-sm text-gray-500 flex items-center">
                                            <FaCalendarAlt className="mr-2 text-[#0D9488]" />
                                            {item.date}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>

                        {bidang.galeri.length === 0 && (
                            <div className="text-center py-12">
                                <FaImages className="text-6xl text-gray-300 mx-auto mb-4" />
                                <h3 className="text-xl font-bold text-gray-500 mb-2">Belum Ada Galeri</h3>
                                <p className="text-gray-400">Galeri kegiatan akan segera ditambahkan</p>
                            </div>
                        )}
                    </div>
                )}
            </div>

            {/* Modal Preview Gambar */}
            {selectedImage && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4"
                    onClick={() => setSelectedImage(null)}
                >
                    <div className="max-w-4xl w-full" onClick={e => e.stopPropagation()}>
                        <div className="relative">
                            <img
                                src={selectedImage.image}
                                alt={selectedImage.title}
                                className="w-full rounded-lg"
                            />
                            <button
                                onClick={() => setSelectedImage(null)}
                                className="absolute top-4 right-4 bg-black/50 text-white p-2 rounded-full hover:bg-black/70 transition-colors"
                            >
                                ✕
                            </button>
                        </div>
                        <div className="mt-4 text-white">
                            <h3 className="text-xl font-bold">{selectedImage.title}</h3>
                            <p className="text-gray-300">{selectedImage.date}</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default BidangPage;